import React, { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Skeleton from '@material-ui/lab/Skeleton';

import ScrollToTop from "./ScrollToTop";
const Home = lazy(() => import('./Site/Home.jsx'));
const AboutUs = lazy(() => import('./Site/AboutUs.jsx'));
const Blogs = lazy(() => import('./Site/Blogs.jsx'));
const BlogDetail = lazy(() => import('./Blog/BlogDetail.jsx'));
const Careers = lazy(() => import('./Site/Careers.jsx'));
const Gallery = lazy(() => import('./Site/Gallery.jsx'));
const ContactUs = lazy(() => import('./Site/ContactUs.jsx'));
const Resort = lazy(() => import('./Resort/Resort.jsx'));
const Rooms = lazy(() => import('./Room/Rooms.jsx'));
const Dinining = lazy(() => import('./Resort/Dinining.jsx'));
const Facilities = lazy(() => import('./Resort/Facilities.jsx'));
const Activities = lazy(() => import('./Resort/Activities.jsx'));
const PlaceToVisit = lazy(() => import('./Resort/PlaceToVisit.jsx'));
const DestinationWedding = lazy(() => import('./Resort/DestinationWedding.jsx'));
const PhotoGallery = lazy(() => import('./Resort/PhotoGallery.jsx'));
const Location = lazy(() => import('./Resort/Location.jsx'));
const RoomList = lazy(() => import('./Room/RoomList.jsx'));
const Checkout = lazy(() => import('./Checkout/Checkout.jsx'));

const styles = makeStyles((theme) => ({
	root: {
		flex: 1,
	},
}));

export default function Content() {
	const classes = styles();
	const renderLoader = () =>  <Skeleton animation="wave" variant="rect" height={500} />;

	return (
		<Suspense fallback={renderLoader()}>
		<div className={classes.root}>
		<ScrollToTop />
			<Switch>
				<Route path="/" exact component={Home} />
				<Route path="/about-us" component={AboutUs} />
				<Route path="/blogs" component={Blogs} />
				<Route path="/blog/:id" component={BlogDetail} />
				<Route path="/careers" component={Careers} />
				<Route path="/gallery" component={Gallery} />
				<Route path="/contact-us" component={ContactUs} />
				<Route path="/resort/:slug" component={Resort} />
				<Route path="/rooms/:slug" component={Rooms} />
				<Route path="/dinining/:slug" component={Dinining} />
				<Route path="/facilities/:slug" component={Facilities} />
				<Route path="/activities/:slug" component={Activities} />
				<Route path="/place-to-visit/:slug" component={PlaceToVisit} />
				<Route path="/destination-wedding/:slug" component={DestinationWedding} />
				<Route path="/photo-gallery/:slug" component={PhotoGallery} />
				<Route path="/location/:slug" component={Location} />
				<Route path="/roomlist" component={RoomList} />
				<Route path="/checkout" component={Checkout} />
			</Switch>
		</div>
    	</Suspense>
	);
}
